// Fallback content used until CMS content loads (keeps site fully rendered).
export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Specialister i døre og vinduer",
    line1: "Vi rådgiver ud fra dit hus",
    line2: "– ikke ud fra, hvad der",
    line3: "er nemmest at sælge",
    intro:
      "Hos Hagelund får du ikke bare et tilbud på nye døre og vinduer. Du får en gennemtænkt løsning, hvor materialer, æstetik og udførelse passer til dit hus – og hænger sammen fra start.",
    cta: "Book rådgivning",
  },
  contact: {
    phone: "22 56 14 15",
    email: "ch@hagelund-aps.dk",
    address: "Augustvej 7, 2860 Søborg",
    cvr: "39651017",
  },
};

export const telHref = (phone) => `tel:+45${(phone || "").replace(/\s/g, "")}`;
export const mailHref = (email) => `mailto:${email}`;
